import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, Optional } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { DxDataGridComponent, DxSelectBoxComponent } from 'devextreme-angular';
import { DataService } from '../core/data.service';
import { FormMode } from '../shared/enums';
import { ModalService } from '../shared/modal/modal.service';
import { ActiveModal } from '../shared/modal/modal.service';
import { RecurrentLoadingItemFormComponent } from './recurrent-loadingitem-form.component';
import { LoadingTemplate } from '../shared/models/loading-template';
import { RecurrencyPattern } from '../shared/models/recurrency-pattern';
import DataSource from 'devextreme/data/data_source';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/debounceTime';

@Component({
  selector: 'app-recurrent-loading-form',
  templateUrl: 'recurrent-loading-form.component.html',
  styleUrls: ['recurrent-loading-form.component.css']
})
export class RecurrentLoadingFormComponent implements AfterViewInit, OnInit {
  @ViewChild(NgForm) form: NgForm;
  @ViewChild(DxSelectBoxComponent) locationSelect: DxSelectBoxComponent;
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @Input() loadingTemplate: LoadingTemplate;
  @Output() loadingTemplateSaved = new EventEmitter();
  loadingTemplateModel: LoadingTemplate;
  recurrencyPatternModel: RecurrencyPattern;

  formMode: FormMode;
  enum = { FormMode };
  locationSource: DataSource;
  locationFilter = new BehaviorSubject({});

  constructor(
    private notificationsService: NotificationsService,
    private modalService: ModalService,
    private dataService: DataService,
    private route: ActivatedRoute,
    @Optional() private activeModal: ActiveModal
  ) { }

  get locationKey() {
    return this.createLocationKey({ id: this.loadingTemplateModel.loadlocationID });
  }

  set locationKey(key) {
    let val = key && JSON.parse(key);
    Object.assign(this.loadingTemplateModel, {
      loadlocationID: val && val.id || null
    });
    this.form.form.markAsDirty();
  }

  ngOnInit() {
    this.loadingTemplate = this.loadingTemplate || this.route.snapshot.data['loadingTemplate'];
    this.formMode = this.loadingTemplate ? FormMode.Edit : FormMode.Create;
    this.prepareModel();

    this.locationSource = new DataSource(<any>{
      paginate: true,
      pageSize: 20,
      key: 'key',
      byKey: key => {
        let { id } = JSON.parse(key);
        return this.dataService.getLoadLocation(id);
      },
      load: opts => {
        let f = this.locationFilter.getValue();
        opts = (({ skip, take }) => ({ skip, take }))(opts);
        opts.filter = Object.keys(f).reduce((obj, k) => f[k] ? (obj[k] = f[k]) && obj : obj, {});
        return this.dataService.getLoadLocations(opts);
      },
      map: location => {
        location.key = this.createLocationKey(location);
        return location;
      }
    });

    this.locationFilter
      .debounceTime(300)
      .subscribe(value => {
        this.locationSelect.instance['_searchDataSource']();
      });
  }

  ngAfterViewInit() {
    this.dataGrid.instance.option({
      columnAutoWidth: true,
      editing: { texts: { confirmDeleteMessage: '' } },
      hoverStateEnabled: true,
      onRowRemoved: () => this.form.form.markAsDirty(),
      showBorders: true
    });

    this.locationSelect.instance.option({
      allowClearing: false,
      onOpened: e => {
        let popup = e.component._popup;
        if (!popup._$search) {
          let searchTemplate = e.component.option('integrationOptions.templates')['search'];
          if (searchTemplate) {
            let search = searchTemplate.render({ model: {} });
            popup._$search = search.prependTo(popup.overlayContent());

            let _setContentHeightOld = popup._setContentHeight;
            popup._setContentHeight = function() {
              _setContentHeightOld.call(this);
              if (!this._disallowUpdateContentHeight()) {
                if (this._$search && this._$search.is(':visible')) {
                  let popupContentHeight = parseInt(this.content().css('height'));
                  popupContentHeight -= this._$search.get(0).getBoundingClientRect().height || 0;
                  this.content().css({ height: popupContentHeight });
                }
              }
            };

            e.component._refreshPopupVisibility = function() {
              if (this.option('opened')) {
                  this._dimensionChanged();
              }
            };

            e.component._dimensionChanged();
          }
        }
      }
    });
  }

  searchLocations(value) {
    this.locationFilter.next(value);
  }

  prepareModel() {
    if (this.formMode === FormMode.Create) {
      this.loadingTemplate = new LoadingTemplate();
    }
    this.loadingTemplate.recurrencyPattern = this.loadingTemplate.recurrencyPattern || new RecurrencyPattern();
    this.loadingTemplate.recurrencyPattern.changeDate = null;
    this.loadingTemplateModel = { ...this.loadingTemplate, loadingItemTemplates: JSON.parse(JSON.stringify(this.loadingTemplate.loadingItemTemplates)) };
    this.recurrencyPatternModel = { ...this.loadingTemplate.recurrencyPattern };
  }

  createLocationKey(location) {
    let keyProps = ['id'];
    let valid = location && keyProps.every(prop => location[prop]);
    return !valid ? null : JSON.stringify(keyProps.reduce((keyObj, prop) => (keyObj[prop] = location[prop]) && keyObj, {}));
  }

  onSubmit(form) {
    if (this.loadingTemplateModel.loadlocationID == null || this.loadingTemplateModel.loadlocationID < 1) {
      this.notificationsService.error('Missing Value', 'Select the load location.');
      return;
    }
      this.loadingTemplate = { ...this.loadingTemplateModel, recurrencyPattern: { ...this.recurrencyPatternModel }  };
      this.loadingTemplateSaved.emit(this.loadingTemplate);
      this.activeModal.dismiss();
  }

  revertChanges(form) {
    this.activeModal.dismiss();
  }

  showProductModal() {
    let modal = this.modalService.open(RecurrentLoadingItemFormComponent);
    modal.componentInstance.addedItem.subscribe(loadingItemTemplate => {
      console.log(loadingItemTemplate);
      loadingItemTemplate.loadingTemplateID = this.loadingTemplateModel.id;
      if (loadingItemTemplate.qty == null || loadingItemTemplate.qty == '') {
        loadingItemTemplate.qty = 0;
      }
      this.loadingTemplateModel.loadingItemTemplates.push(loadingItemTemplate);
      this.form.form.markAsDirty();
    });
  }
  onRowUpdated(e) {
    if (e.key.qty == null) {
        e.key.qty = 0;
    }
  }
  onCellPrepared(e) {
    if (e.rowType === 'header' && e.column.command === 'edit') {
     /*
      let headerElement = e.cellElement;
      let template = '<div style="text-align: center;"><i class="fa fa-plus fa-lg" aria-hidden="true" onclick="this.showProductModal()"></i></div>';
      headerElement.html(template);*/

    } else if (e.rowType === 'data' && e.column.command === 'edit') {
        let cellElement = e.cellElement;
        let deleteLink = cellElement[0].querySelector('.dx-link-delete');
        // deleteLink.classList.add('dx-icon-remove');
        if (deleteLink) {
        deleteLink.textContent = 'Remove';
        }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/recurrence/recurrent-loading-form.component.ts